/* tslint:disable */
/* eslint-disable */
/**
 * Pitango Market API
 * Canonical public and administrative HTTP API contract.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
    AdminGetOrdersOrderByCols,
    AdminOrderDirection,
    AdminOrdersPayloadIAddOrderCommentRequest,
    AdminOrdersPayloadIAddOrderStatusNoteRequest,
    AdminOrdersPayloadICreateOrderChangeRequest,
    AdminOrdersPayloadISetOrderStatusRequest,
    AdminOrdersPayloadIUpdateOrderContactDetailsRequest,
    AdminOrdersPayloadIUpdateOrderShippingDetailsRequest,
    AdminOrdersRequestGenerateInvoiceRequest,
    AdminOrdersResponseAddOrderCommentResponse,
    AdminOrdersResponseAddOrderStatusNoteResponse,
    AdminOrdersResponseCreateOrderChangeRequestResponse,
    AdminOrdersResponseGenerateInvoiceResponse,
    AdminOrdersResponseGetOrderChangeRequestResponse,
    AdminOrdersResponseGetOrderChangeRequestsExportResponse,
    AdminOrdersResponseGetOrderChangeRequestsResponse,
    AdminOrdersResponseGetOrderCommentsResponse,
    AdminOrdersResponseGetOrderDetailsResponse,
    AdminOrdersResponseGetOrderStatusHistoryResponse,
    AdminOrdersResponseGetOrdersResponse,
    AdminOrdersResponseSetOrderStatusResponse,
    AdminOrdersResponseUpdateOrderContactDetailsResponse,
    AdminOrdersResponseUpdateOrderShippingDetailsResponse,
    ApiErrorEnvelope,
    LanguageCode,
    OrdersPayloadIApproveOrderChangeRequest,
    OrdersPayloadIRejectOrderChangeRequest,
    OrdersRequestFinalizeOrderRequest,
    OrdersRequestGenerateInvoiceRequest,
    OrdersResponseApproveOrderChangeResponse,
    OrdersResponseFinalizeOrderResponse,
    OrdersResponseGenerateInvoiceResponse,
    OrdersResponseGetDeliveryProgressResponse,
    OrdersResponseGetLatestOrderChangeResponse,
    OrdersResponseGetOrderItemsResponse,
    OrdersResponseGetOrdersResponse,
    OrdersResponseGetPendingOrderChangeResponse,
    OrdersResponseRejectOrderChangeResponse,
} from '../models/index';

export interface AdminOrdersAddOrderCommentRequest {
    orderId: string;
    adminOrdersPayloadIAddOrderCommentRequest: AdminOrdersPayloadIAddOrderCommentRequest;
}

export interface AdminOrdersAddOrderStatusNoteRequest {
    orderId: string;
    adminOrdersPayloadIAddOrderStatusNoteRequest: AdminOrdersPayloadIAddOrderStatusNoteRequest;
}

export interface AdminOrdersCreateOrderChangeRequestRequest {
    orderId: string;
    adminOrdersPayloadICreateOrderChangeRequest: AdminOrdersPayloadICreateOrderChangeRequest;
}

export interface AdminOrdersGenerateInvoiceRequest {
    orderId: string;
    adminOrdersRequestGenerateInvoiceRequest: AdminOrdersRequestGenerateInvoiceRequest;
}

export interface AdminOrdersGetOrderChangeRequestRequest {
    orderId: string;
    changeId: string;
}

export interface AdminOrdersGetOrderChangeRequestsRequest {
    orderId: string;
}

export interface AdminOrdersGetOrderChangeRequestsExportRequest {
    orderId: string;
}

export interface AdminOrdersGetOrderCommentsRequest {
    orderId: string;
}

export interface AdminOrdersGetOrderDetailsRequest {
    orderId: string;
}

export interface AdminOrdersGetOrderStatusHistoryRequest {
    orderId: string;
}

export interface AdminOrdersGetOrdersRequest {
    orderNumber?: string;
    userId?: string;
    statusId?: string;
    createdFrom?: string;
    createdTo?: string;
    minTotal?: number;
    maxTotal?: number;
    q?: string;
    pageIndex?: number;
    pageSize?: number;
    sortBy?: AdminGetOrdersOrderByCols;
    sortDir?: AdminOrderDirection;
}

export interface AdminOrdersSetOrderStatusRequest {
    orderId: string;
    adminOrdersPayloadISetOrderStatusRequest: AdminOrdersPayloadISetOrderStatusRequest;
}

export interface AdminOrdersUpdateOrderContactDetailsRequest {
    orderId: string;
    adminOrdersPayloadIUpdateOrderContactDetailsRequest: AdminOrdersPayloadIUpdateOrderContactDetailsRequest;
}

export interface AdminOrdersUpdateOrderShippingDetailsRequest {
    orderId: string;
    adminOrdersPayloadIUpdateOrderShippingDetailsRequest: AdminOrdersPayloadIUpdateOrderShippingDetailsRequest;
}

export interface OrdersApproveOrderChangeRequest {
    orderId: string;
    changeId: string;
    ordersPayloadIApproveOrderChangeRequest: OrdersPayloadIApproveOrderChangeRequest;
}

export interface OrdersFinalizeOrderRequest {
    ordersRequestFinalizeOrderRequest: OrdersRequestFinalizeOrderRequest;
}

export interface OrdersGenerateInvoiceRequest {
    orderId: string;
    ordersRequestGenerateInvoiceRequest: OrdersRequestGenerateInvoiceRequest;
}

export interface OrdersGetDeliveryProgressRequest {
    orderNumber: string;
}

export interface OrdersGetLatestOrderChangeRequest {
    orderId: string;
}

export interface OrdersGetOrderItemsRequest {
    languageCode: LanguageCode;
    orderNumber: string;
}

export interface OrdersGetOrdersRequest {
    languageCode: LanguageCode;
    orderNumber?: string;
}

export interface OrdersGetPendingOrderChangeRequest {
    orderId: string;
}

export interface OrdersRejectOrderChangeRequest {
    orderId: string;
    changeId: string;
    ordersPayloadIRejectOrderChangeRequest: OrdersPayloadIRejectOrderChangeRequest;
}

/**
 *
 */
export class OrdersApi extends runtime.BaseAPI {

    /**
     * Creates request options for adminOrdersAddOrderComment without sending the request
     */
    async adminOrdersAddOrderCommentRequestOpts(requestParameters: AdminOrdersAddOrderCommentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling adminOrdersAddOrderComment().'
            );
        }

        if (requestParameters['adminOrdersPayloadIAddOrderCommentRequest'] == null) {
            throw new runtime.RequiredError(
                'adminOrdersPayloadIAddOrderCommentRequest',
                'Required parameter "adminOrdersPayloadIAddOrderCommentRequest" was null or undefined when calling adminOrdersAddOrderComment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/orders/{orderId}/comments`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminOrdersPayloadIAddOrderCommentRequest'],
        };
    }

    /**
     * Add Order Comment
     */
    async adminOrdersAddOrderCommentRaw(requestParameters: AdminOrdersAddOrderCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrdersResponseAddOrderCommentResponse>> {
        const requestOptions = await this.adminOrdersAddOrderCommentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Add Order Comment
     */
    async adminOrdersAddOrderComment(requestParameters: AdminOrdersAddOrderCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrdersResponseAddOrderCommentResponse> {
        const response = await this.adminOrdersAddOrderCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminOrdersAddOrderStatusNote without sending the request
     */
    async adminOrdersAddOrderStatusNoteRequestOpts(requestParameters: AdminOrdersAddOrderStatusNoteRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling adminOrdersAddOrderStatusNote().'
            );
        }

        if (requestParameters['adminOrdersPayloadIAddOrderStatusNoteRequest'] == null) {
            throw new runtime.RequiredError(
                'adminOrdersPayloadIAddOrderStatusNoteRequest',
                'Required parameter "adminOrdersPayloadIAddOrderStatusNoteRequest" was null or undefined when calling adminOrdersAddOrderStatusNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/orders/{orderId}/status-note`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminOrdersPayloadIAddOrderStatusNoteRequest'],
        };
    }

    /**
     * Add Order Status Note
     */
    async adminOrdersAddOrderStatusNoteRaw(requestParameters: AdminOrdersAddOrderStatusNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrdersResponseAddOrderStatusNoteResponse>> {
        const requestOptions = await this.adminOrdersAddOrderStatusNoteRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Add Order Status Note
     */
    async adminOrdersAddOrderStatusNote(requestParameters: AdminOrdersAddOrderStatusNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrdersResponseAddOrderStatusNoteResponse> {
        const response = await this.adminOrdersAddOrderStatusNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminOrdersCreateOrderChangeRequest without sending the request
     */
    async adminOrdersCreateOrderChangeRequestRequestOpts(requestParameters: AdminOrdersCreateOrderChangeRequestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling adminOrdersCreateOrderChangeRequest().'
            );
        }

        if (requestParameters['adminOrdersPayloadICreateOrderChangeRequest'] == null) {
            throw new runtime.RequiredError(
                'adminOrdersPayloadICreateOrderChangeRequest',
                'Required parameter "adminOrdersPayloadICreateOrderChangeRequest" was null or undefined when calling adminOrdersCreateOrderChangeRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/orders/{orderId}/change-requests`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminOrdersPayloadICreateOrderChangeRequest'],
        };
    }

    /**
     * Create Order Change Request
     */
    async adminOrdersCreateOrderChangeRequestRaw(requestParameters: AdminOrdersCreateOrderChangeRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrdersResponseCreateOrderChangeRequestResponse>> {
        const requestOptions = await this.adminOrdersCreateOrderChangeRequestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create Order Change Request
     */
    async adminOrdersCreateOrderChangeRequest(requestParameters: AdminOrdersCreateOrderChangeRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrdersResponseCreateOrderChangeRequestResponse> {
        const response = await this.adminOrdersCreateOrderChangeRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminOrdersGenerateInvoice without sending the request
     */
    async adminOrdersGenerateInvoiceRequestOpts(requestParameters: AdminOrdersGenerateInvoiceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling adminOrdersGenerateInvoice().'
            );
        }

        if (requestParameters['adminOrdersRequestGenerateInvoiceRequest'] == null) {
            throw new runtime.RequiredError(
                'adminOrdersRequestGenerateInvoiceRequest',
                'Required parameter "adminOrdersRequestGenerateInvoiceRequest" was null or undefined when calling adminOrdersGenerateInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/orders/{orderId}/invoice`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminOrdersRequestGenerateInvoiceRequest'],
        };
    }

    /**
     * Generate Invoice
     */
    async adminOrdersGenerateInvoiceRaw(requestParameters: AdminOrdersGenerateInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrdersResponseGenerateInvoiceResponse>> {
        const requestOptions = await this.adminOrdersGenerateInvoiceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Generate Invoice
     */
    async adminOrdersGenerateInvoice(requestParameters: AdminOrdersGenerateInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrdersResponseGenerateInvoiceResponse> {
        const response = await this.adminOrdersGenerateInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminOrdersGetOrderChangeRequest without sending the request
     */
    async adminOrdersGetOrderChangeRequestRequestOpts(requestParameters: AdminOrdersGetOrderChangeRequestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling adminOrdersGetOrderChangeRequest().'
            );
        }

        if (requestParameters['changeId'] == null) {
            throw new runtime.RequiredError(
                'changeId',
                'Required parameter "changeId" was null or undefined when calling adminOrdersGetOrderChangeRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/orders/{orderId}/change-requests/{changeId}`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));
        urlPath = urlPath.replace('{changeId}', encodeURIComponent(String(requestParameters['changeId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Order Change Request
     */
    async adminOrdersGetOrderChangeRequestRaw(requestParameters: AdminOrdersGetOrderChangeRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrdersResponseGetOrderChangeRequestResponse>> {
        const requestOptions = await this.adminOrdersGetOrderChangeRequestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Order Change Request
     */
    async adminOrdersGetOrderChangeRequest(requestParameters: AdminOrdersGetOrderChangeRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrdersResponseGetOrderChangeRequestResponse> {
        const response = await this.adminOrdersGetOrderChangeRequestRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminOrdersGetOrderChangeRequests without sending the request
     */
    async adminOrdersGetOrderChangeRequestsRequestOpts(requestParameters: AdminOrdersGetOrderChangeRequestsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling adminOrdersGetOrderChangeRequests().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/orders/{orderId}/change-requests`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Order Change Requests
     */
    async adminOrdersGetOrderChangeRequestsRaw(requestParameters: AdminOrdersGetOrderChangeRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrdersResponseGetOrderChangeRequestsResponse>> {
        const requestOptions = await this.adminOrdersGetOrderChangeRequestsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Order Change Requests
     */
    async adminOrdersGetOrderChangeRequests(requestParameters: AdminOrdersGetOrderChangeRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrdersResponseGetOrderChangeRequestsResponse> {
        const response = await this.adminOrdersGetOrderChangeRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminOrdersGetOrderChangeRequestsExport without sending the request
     */
    async adminOrdersGetOrderChangeRequestsExportRequestOpts(requestParameters: AdminOrdersGetOrderChangeRequestsExportRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling adminOrdersGetOrderChangeRequestsExport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/orders/{orderId}/change-requests/export`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Order Change Requests Export
     */
    async adminOrdersGetOrderChangeRequestsExportRaw(requestParameters: AdminOrdersGetOrderChangeRequestsExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrdersResponseGetOrderChangeRequestsExportResponse>> {
        const requestOptions = await this.adminOrdersGetOrderChangeRequestsExportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Order Change Requests Export
     */
    async adminOrdersGetOrderChangeRequestsExport(requestParameters: AdminOrdersGetOrderChangeRequestsExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrdersResponseGetOrderChangeRequestsExportResponse> {
        const response = await this.adminOrdersGetOrderChangeRequestsExportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminOrdersGetOrderComments without sending the request
     */
    async adminOrdersGetOrderCommentsRequestOpts(requestParameters: AdminOrdersGetOrderCommentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling adminOrdersGetOrderComments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/orders/{orderId}/comments`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Order Comments
     */
    async adminOrdersGetOrderCommentsRaw(requestParameters: AdminOrdersGetOrderCommentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrdersResponseGetOrderCommentsResponse>> {
        const requestOptions = await this.adminOrdersGetOrderCommentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Order Comments
     */
    async adminOrdersGetOrderComments(requestParameters: AdminOrdersGetOrderCommentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrdersResponseGetOrderCommentsResponse> {
        const response = await this.adminOrdersGetOrderCommentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminOrdersGetOrderDetails without sending the request
     */
    async adminOrdersGetOrderDetailsRequestOpts(requestParameters: AdminOrdersGetOrderDetailsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling adminOrdersGetOrderDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/orders/{orderId}/details`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Order Details
     */
    async adminOrdersGetOrderDetailsRaw(requestParameters: AdminOrdersGetOrderDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrdersResponseGetOrderDetailsResponse>> {
        const requestOptions = await this.adminOrdersGetOrderDetailsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Order Details
     */
    async adminOrdersGetOrderDetails(requestParameters: AdminOrdersGetOrderDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrdersResponseGetOrderDetailsResponse> {
        const response = await this.adminOrdersGetOrderDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminOrdersGetOrderStatusHistory without sending the request
     */
    async adminOrdersGetOrderStatusHistoryRequestOpts(requestParameters: AdminOrdersGetOrderStatusHistoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling adminOrdersGetOrderStatusHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/orders/{orderId}/status-history`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Order Status History
     */
    async adminOrdersGetOrderStatusHistoryRaw(requestParameters: AdminOrdersGetOrderStatusHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrdersResponseGetOrderStatusHistoryResponse>> {
        const requestOptions = await this.adminOrdersGetOrderStatusHistoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Order Status History
     */
    async adminOrdersGetOrderStatusHistory(requestParameters: AdminOrdersGetOrderStatusHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrdersResponseGetOrderStatusHistoryResponse> {
        const response = await this.adminOrdersGetOrderStatusHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminOrdersGetOrders without sending the request
     */
    async adminOrdersGetOrdersRequestOpts(requestParameters: AdminOrdersGetOrdersRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['orderNumber'] != null) {
            queryParameters['orderNumber'] = requestParameters['orderNumber'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['statusId'] != null) {
            queryParameters['statusId'] = requestParameters['statusId'];
        }

        if (requestParameters['createdFrom'] != null) {
            queryParameters['createdFrom'] = requestParameters['createdFrom'];
        }

        if (requestParameters['createdTo'] != null) {
            queryParameters['createdTo'] = requestParameters['createdTo'];
        }

        if (requestParameters['minTotal'] != null) {
            queryParameters['minTotal'] = requestParameters['minTotal'];
        }

        if (requestParameters['maxTotal'] != null) {
            queryParameters['maxTotal'] = requestParameters['maxTotal'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['pageIndex'] != null) {
            queryParameters['pageIndex'] = requestParameters['pageIndex'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortDir'] != null) {
            queryParameters['sortDir'] = requestParameters['sortDir'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/orders`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Orders
     */
    async adminOrdersGetOrdersRaw(requestParameters: AdminOrdersGetOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrdersResponseGetOrdersResponse>> {
        const requestOptions = await this.adminOrdersGetOrdersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Orders
     */
    async adminOrdersGetOrders(requestParameters: AdminOrdersGetOrdersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrdersResponseGetOrdersResponse> {
        const response = await this.adminOrdersGetOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminOrdersSetOrderStatus without sending the request
     */
    async adminOrdersSetOrderStatusRequestOpts(requestParameters: AdminOrdersSetOrderStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling adminOrdersSetOrderStatus().'
            );
        }

        if (requestParameters['adminOrdersPayloadISetOrderStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'adminOrdersPayloadISetOrderStatusRequest',
                'Required parameter "adminOrdersPayloadISetOrderStatusRequest" was null or undefined when calling adminOrdersSetOrderStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/orders/{orderId}/status`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminOrdersPayloadISetOrderStatusRequest'],
        };
    }

    /**
     * Set Order Status
     */
    async adminOrdersSetOrderStatusRaw(requestParameters: AdminOrdersSetOrderStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrdersResponseSetOrderStatusResponse>> {
        const requestOptions = await this.adminOrdersSetOrderStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Set Order Status
     */
    async adminOrdersSetOrderStatus(requestParameters: AdminOrdersSetOrderStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrdersResponseSetOrderStatusResponse> {
        const response = await this.adminOrdersSetOrderStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminOrdersUpdateOrderContactDetails without sending the request
     */
    async adminOrdersUpdateOrderContactDetailsRequestOpts(requestParameters: AdminOrdersUpdateOrderContactDetailsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling adminOrdersUpdateOrderContactDetails().'
            );
        }

        if (requestParameters['adminOrdersPayloadIUpdateOrderContactDetailsRequest'] == null) {
            throw new runtime.RequiredError(
                'adminOrdersPayloadIUpdateOrderContactDetailsRequest',
                'Required parameter "adminOrdersPayloadIUpdateOrderContactDetailsRequest" was null or undefined when calling adminOrdersUpdateOrderContactDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/orders/{orderId}/contact`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminOrdersPayloadIUpdateOrderContactDetailsRequest'],
        };
    }

    /**
     * Update Order Contact Details
     */
    async adminOrdersUpdateOrderContactDetailsRaw(requestParameters: AdminOrdersUpdateOrderContactDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrdersResponseUpdateOrderContactDetailsResponse>> {
        const requestOptions = await this.adminOrdersUpdateOrderContactDetailsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update Order Contact Details
     */
    async adminOrdersUpdateOrderContactDetails(requestParameters: AdminOrdersUpdateOrderContactDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrdersResponseUpdateOrderContactDetailsResponse> {
        const response = await this.adminOrdersUpdateOrderContactDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminOrdersUpdateOrderShippingDetails without sending the request
     */
    async adminOrdersUpdateOrderShippingDetailsRequestOpts(requestParameters: AdminOrdersUpdateOrderShippingDetailsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling adminOrdersUpdateOrderShippingDetails().'
            );
        }

        if (requestParameters['adminOrdersPayloadIUpdateOrderShippingDetailsRequest'] == null) {
            throw new runtime.RequiredError(
                'adminOrdersPayloadIUpdateOrderShippingDetailsRequest',
                'Required parameter "adminOrdersPayloadIUpdateOrderShippingDetailsRequest" was null or undefined when calling adminOrdersUpdateOrderShippingDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/orders/{orderId}/shipping`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminOrdersPayloadIUpdateOrderShippingDetailsRequest'],
        };
    }

    /**
     * Update Order Shipping Details
     */
    async adminOrdersUpdateOrderShippingDetailsRaw(requestParameters: AdminOrdersUpdateOrderShippingDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOrdersResponseUpdateOrderShippingDetailsResponse>> {
        const requestOptions = await this.adminOrdersUpdateOrderShippingDetailsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update Order Shipping Details
     */
    async adminOrdersUpdateOrderShippingDetails(requestParameters: AdminOrdersUpdateOrderShippingDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOrdersResponseUpdateOrderShippingDetailsResponse> {
        const response = await this.adminOrdersUpdateOrderShippingDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersApproveOrderChange without sending the request
     */
    async ordersApproveOrderChangeRequestOpts(requestParameters: OrdersApproveOrderChangeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling ordersApproveOrderChange().'
            );
        }

        if (requestParameters['changeId'] == null) {
            throw new runtime.RequiredError(
                'changeId',
                'Required parameter "changeId" was null or undefined when calling ordersApproveOrderChange().'
            );
        }

        if (requestParameters['ordersPayloadIApproveOrderChangeRequest'] == null) {
            throw new runtime.RequiredError(
                'ordersPayloadIApproveOrderChangeRequest',
                'Required parameter "ordersPayloadIApproveOrderChangeRequest" was null or undefined when calling ordersApproveOrderChange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/orders/changes/{orderId}/{changeId}/approve`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));
        urlPath = urlPath.replace('{changeId}', encodeURIComponent(String(requestParameters['changeId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ordersPayloadIApproveOrderChangeRequest'],
        };
    }

    /**
     * Approve Order Change
     */
    async ordersApproveOrderChangeRaw(requestParameters: OrdersApproveOrderChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdersResponseApproveOrderChangeResponse>> {
        const requestOptions = await this.ordersApproveOrderChangeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Approve Order Change
     */
    async ordersApproveOrderChange(requestParameters: OrdersApproveOrderChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdersResponseApproveOrderChangeResponse> {
        const response = await this.ordersApproveOrderChangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersFinalizeOrder without sending the request
     */
    async ordersFinalizeOrderRequestOpts(requestParameters: OrdersFinalizeOrderRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['ordersRequestFinalizeOrderRequest'] == null) {
            throw new runtime.RequiredError(
                'ordersRequestFinalizeOrderRequest',
                'Required parameter "ordersRequestFinalizeOrderRequest" was null or undefined when calling ordersFinalizeOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/orders`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ordersRequestFinalizeOrderRequest'],
        };
    }

    /**
     * Finalize Order
     */
    async ordersFinalizeOrderRaw(requestParameters: OrdersFinalizeOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdersResponseFinalizeOrderResponse>> {
        const requestOptions = await this.ordersFinalizeOrderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Finalize Order
     */
    async ordersFinalizeOrder(requestParameters: OrdersFinalizeOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdersResponseFinalizeOrderResponse> {
        const response = await this.ordersFinalizeOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGenerateInvoice without sending the request
     */
    async ordersGenerateInvoiceRequestOpts(requestParameters: OrdersGenerateInvoiceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling ordersGenerateInvoice().'
            );
        }

        if (requestParameters['ordersRequestGenerateInvoiceRequest'] == null) {
            throw new runtime.RequiredError(
                'ordersRequestGenerateInvoiceRequest',
                'Required parameter "ordersRequestGenerateInvoiceRequest" was null or undefined when calling ordersGenerateInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/orders/invoice/{orderId}`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ordersRequestGenerateInvoiceRequest'],
        };
    }

    /**
     * Generate Invoice
     */
    async ordersGenerateInvoiceRaw(requestParameters: OrdersGenerateInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdersResponseGenerateInvoiceResponse>> {
        const requestOptions = await this.ordersGenerateInvoiceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Generate Invoice
     */
    async ordersGenerateInvoice(requestParameters: OrdersGenerateInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdersResponseGenerateInvoiceResponse> {
        const response = await this.ordersGenerateInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGetDeliveryProgress without sending the request
     */
    async ordersGetDeliveryProgressRequestOpts(requestParameters: OrdersGetDeliveryProgressRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderNumber'] == null) {
            throw new runtime.RequiredError(
                'orderNumber',
                'Required parameter "orderNumber" was null or undefined when calling ordersGetDeliveryProgress().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/orders/delivery-progress/{orderNumber}`;
        urlPath = urlPath.replace('{orderNumber}', encodeURIComponent(String(requestParameters['orderNumber'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Delivery Progress
     */
    async ordersGetDeliveryProgressRaw(requestParameters: OrdersGetDeliveryProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdersResponseGetDeliveryProgressResponse>> {
        const requestOptions = await this.ordersGetDeliveryProgressRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Delivery Progress
     */
    async ordersGetDeliveryProgress(requestParameters: OrdersGetDeliveryProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdersResponseGetDeliveryProgressResponse> {
        const response = await this.ordersGetDeliveryProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGetLatestOrderChange without sending the request
     */
    async ordersGetLatestOrderChangeRequestOpts(requestParameters: OrdersGetLatestOrderChangeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling ordersGetLatestOrderChange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/orders/changes/{orderId}/latest`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Latest Order Change
     */
    async ordersGetLatestOrderChangeRaw(requestParameters: OrdersGetLatestOrderChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdersResponseGetLatestOrderChangeResponse>> {
        const requestOptions = await this.ordersGetLatestOrderChangeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Latest Order Change
     */
    async ordersGetLatestOrderChange(requestParameters: OrdersGetLatestOrderChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdersResponseGetLatestOrderChangeResponse> {
        const response = await this.ordersGetLatestOrderChangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGetOrderItems without sending the request
     */
    async ordersGetOrderItemsRequestOpts(requestParameters: OrdersGetOrderItemsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling ordersGetOrderItems().'
            );
        }

        if (requestParameters['orderNumber'] == null) {
            throw new runtime.RequiredError(
                'orderNumber',
                'Required parameter "orderNumber" was null or undefined when calling ordersGetOrderItems().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/orders/{languageCode}/{orderNumber}`;
        urlPath = urlPath.replace('{languageCode}', encodeURIComponent(String(requestParameters['languageCode'])));
        urlPath = urlPath.replace('{orderNumber}', encodeURIComponent(String(requestParameters['orderNumber'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Order Items
     */
    async ordersGetOrderItemsRaw(requestParameters: OrdersGetOrderItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdersResponseGetOrderItemsResponse>> {
        const requestOptions = await this.ordersGetOrderItemsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Order Items
     */
    async ordersGetOrderItems(requestParameters: OrdersGetOrderItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdersResponseGetOrderItemsResponse> {
        const response = await this.ordersGetOrderItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGetOrders without sending the request
     */
    async ordersGetOrdersRequestOpts(requestParameters: OrdersGetOrdersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling ordersGetOrders().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderNumber'] != null) {
            queryParameters['orderNumber'] = requestParameters['orderNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/orders/{languageCode}`;
        urlPath = urlPath.replace('{languageCode}', encodeURIComponent(String(requestParameters['languageCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Orders
     */
    async ordersGetOrdersRaw(requestParameters: OrdersGetOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdersResponseGetOrdersResponse>> {
        const requestOptions = await this.ordersGetOrdersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Orders
     */
    async ordersGetOrders(requestParameters: OrdersGetOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdersResponseGetOrdersResponse> {
        const response = await this.ordersGetOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGetPendingOrderChange without sending the request
     */
    async ordersGetPendingOrderChangeRequestOpts(requestParameters: OrdersGetPendingOrderChangeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling ordersGetPendingOrderChange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/orders/changes/{orderId}/pending`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Pending Order Change
     */
    async ordersGetPendingOrderChangeRaw(requestParameters: OrdersGetPendingOrderChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdersResponseGetPendingOrderChangeResponse>> {
        const requestOptions = await this.ordersGetPendingOrderChangeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Pending Order Change
     */
    async ordersGetPendingOrderChange(requestParameters: OrdersGetPendingOrderChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdersResponseGetPendingOrderChangeResponse> {
        const response = await this.ordersGetPendingOrderChangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersRejectOrderChange without sending the request
     */
    async ordersRejectOrderChangeRequestOpts(requestParameters: OrdersRejectOrderChangeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling ordersRejectOrderChange().'
            );
        }

        if (requestParameters['changeId'] == null) {
            throw new runtime.RequiredError(
                'changeId',
                'Required parameter "changeId" was null or undefined when calling ordersRejectOrderChange().'
            );
        }

        if (requestParameters['ordersPayloadIRejectOrderChangeRequest'] == null) {
            throw new runtime.RequiredError(
                'ordersPayloadIRejectOrderChangeRequest',
                'Required parameter "ordersPayloadIRejectOrderChangeRequest" was null or undefined when calling ordersRejectOrderChange().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/orders/changes/{orderId}/{changeId}/reject`;
        urlPath = urlPath.replace('{orderId}', encodeURIComponent(String(requestParameters['orderId'])));
        urlPath = urlPath.replace('{changeId}', encodeURIComponent(String(requestParameters['changeId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ordersPayloadIRejectOrderChangeRequest'],
        };
    }

    /**
     * Reject Order Change
     */
    async ordersRejectOrderChangeRaw(requestParameters: OrdersRejectOrderChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdersResponseRejectOrderChangeResponse>> {
        const requestOptions = await this.ordersRejectOrderChangeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Reject Order Change
     */
    async ordersRejectOrderChange(requestParameters: OrdersRejectOrderChangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdersResponseRejectOrderChangeResponse> {
        const response = await this.ordersRejectOrderChangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
